module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./web/modern/components/quotes/common/quote-contract-and-question/quote-contract-and-question.scss
// module id = ./web/modern/components/quotes/common/quote-contract-and-question/quote-contract-and-question.scss
// module chunks = 0